import './chart.style.less'

import { Doughnut } from 'react-chartjs-2'
import MainWrapper from './MainWrapper'

interface props {
  title: string
  sign?: string
  showLegend?: boolean
  data?: any
  id: string
  periods?: string[]
  onPeriodChange?: (period: string) => any
}

function DoughnutChart(props: props) {
  const {
    data,
    showLegend = true,
    title,
    sign = '',
    id = '',
    periods = [],
    onPeriodChange = () => {},
  } = props
  const options = {
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top' as const,
        display: showLegend,
        labels: {
          usePointStyle: true,
          pointStyle: 'rectRounded',
        },
      },
      datalabels: {
        font: { size: 14 },
        formatter: (val) => {
          return val + sign
        },
      },
    },
  }
  return (
    <MainWrapper
      id={id}
      title={title}
      onPeriodChange={onPeriodChange}
      periods={periods}
    >
      <Doughnut data={data} options={options} />
    </MainWrapper>
  )
}
export default DoughnutChart
